import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500/15 text-primary-400 border border-primary-500/20 mb-3">
            <i className="ri-lightbulb-flash-line mr-1"></i>编辑推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">编辑团队精选的深度专题内容</p>
        </div>

        <div className="flex flex-col gap-4">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href={item.href}
              onClick={(e) => handleClick(e, item.href)}
              className="group flex flex-col lg:flex-row gap-5 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/50 hover:border-primary-500/30 transition-all duration-200 cursor-pointer overflow-hidden"
            >
              <div className="flex-shrink-0 w-full lg:w-64 aspect-[16/10] lg:aspect-auto rounded-lg overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 flex flex-col justify-center min-w-0">
                <span className="inline-block self-start px-2.5 py-1 rounded-full bg-primary-500/15 text-primary-400 text-xs font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 mt-2 leading-relaxed">
                  {item.subtitle}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs text-primary-400">
                  <span>查看详情</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}